export default [
    {
        // [0]
        key: "transaction",
        label: app.$i18n.t("Transaction"),
        tdClass: "text-center",
        thClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "transaction_type",
        label: app.$i18n.t("Transaction type"),
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "bank",
        label: app.$i18n.t("Bank"),
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "amount",
        label: app.$i18n.t("Amount"),
        tdClass: "text-center",
        thClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "status",
        label: app.$i18n.t("Status"),
        tdClass: "text-center",
        thClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "created_at",
        label: app.$i18n.t("Created at"),
        sortable: true,
        visible: true,
    },
    {
        // [13]
        key: "actions",
        label: app.$i18n.t("Actions"),
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
]